var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduleClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.21375C11.7463 8.96 11.3263 8.96 11.0725 9.21375L7.26625 13.02L5.875 11.6287C5.62125 11.375 5.20125 11.375 4.9475 11.6287C4.69375 11.8825 4.69375 12.3025 4.9475 12.5563L6.645 14.2538C6.98625 14.595 7.5375 14.595 7.87875 14.2538L11.9913 10.1413C12.2537 9.8875 12.2537 9.4675 12 9.21375ZM14.625 2.625H13.75V1.75C13.75 1.26875 13.3562 0.875 12.875 0.875C12.3938 0.875 12 1.26875 12 1.75V2.625H5V1.75C5 1.26875 4.60625 0.875 4.125 0.875C3.64375 0.875 3.25 1.26875 3.25 1.75V2.625H2.375C1.40375 2.625 0.63375 3.4125 0.63375 4.375L0.625 16.625C0.625 17.5875 1.40375 18.375 2.375 18.375H14.625C15.5875 18.375 16.375 17.5875 16.375 16.625V4.375C16.375 3.4125 15.5875 2.625 14.625 2.625ZM13.75 16.625H3.25C2.76875 16.625 2.375 16.2312 2.375 15.75V7H14.625V15.75C14.625 16.2312 14.2312 16.625 13.75 16.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleClock);
export default __webpack_public_path__ + "static/media/schedule_clock.23174cc93988130b504aba6bce10c1ec.svg";
export { ForwardRef as ReactComponent };